import { render, staticRenderFns } from "./ui-not-found.vue?vue&type=template&id=6228f45f&"
import script from "./ui-not-found.vue?vue&type=script&lang=ts&"
export * from "./ui-not-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports